export default __webpack_public_path__ + "static/media/Ellipse one.e892b105.svg";